<p-listbox [(ngModel)]="selectedItem" [options]="items" (onChange)="select($any($event.value))" optionLabel="name">
  <ng-template let-item pTemplate="selectedItem">
    <img class="list-image" src="../../../../assets/icons/{{ item.icon }}.svg" />
    <div class="list-text">
      <bdi>{{ item.text }}</bdi>
    </div>
  </ng-template>
  <ng-template let-item pTemplate="item">
    <img class="list-image" src="../../../../assets/icons/{{ item.icon }}.svg" />
    <div class="list-text">
      <bdi>{{ item.text }}</bdi>
    </div>
  </ng-template>
</p-listbox>
